/**
 * Swappable persistence backend for table filter state — localStorage today,
 * a REST-backed adapter later — without changing any call sites.
 */
export interface TableStatePersistenceAdapter {
  get<T>(key: string): T | null;
  set<T>(key: string, value: T): void;
  remove(key: string): void;
}

export const localStorageAdapter: TableStatePersistenceAdapter = {
  get<T>(key: string): T | null {
    try {
      const item = localStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : null;
    } catch {
      return null;
    }
  },
  set<T>(key: string, value: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Silently ignore (e.g. storage disabled/quota exceeded)
    }
  },
  remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      // Silently ignore
    }
  },
};
